import axiosInstance from "./AxiosInstance";

// Fetch roles (you can add pagination or filters as needed)
export function getRoles(pagination, pageid,search_by = "", search_keyword = "") {
  return axiosInstance.post("/admin/getRoles", { pagination, pageid , search_by, search_keyword});
}

export function getModuleList() {
  return axiosInstance.post("/admin/getModules");
}

export function getRoleModules(pagination, pageid,search_by = "", search_keyword = "",sort_by ="", sort_order ="") {
  return axiosInstance.post("/admin/getRoles", {pagination, pageid,search_by, search_keyword, sort_by, sort_order});
}

// Add or Update Role
export function addOrUpdateRole(roleData) {
  return axiosInstance.post("/admin/addUpdateRole", {
    ...roleData,
    role_id: roleData.role_id,
  });
}

// Delete Role
export function deleteRole(roleData) {
  return axiosInstance.post("/admin/deleteRole", roleData);
}

// Optional: format response (if needed to unify role_id)
export function formatRoles(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((role) => ({
      ...role,
      role_id: role.role_id || role._id || role.id,
    }));
  }

  let roles = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      roles.push({
        ...responseData[key],
        role_id:
          responseData[key].role_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return roles;
}
